import styled from "styled-components"

import { COLOR } from "../../component-library/design/color/color.constants"
import { SPACING } from "../../component-library/design/spacing/spacing.constants"
import { FONT_SIZE } from "../../component-library/design/typography/typography.constants"
import {
  Body,
  TextLink,
} from "../../component-library/design/typography/typography.styles"

const StyledTextLink = styled(TextLink)`
  font-size: ${FONT_SIZE.SMALL};
  cursor: pointer;
`

const ErrorMessage = styled(Body)`
  color: ${COLOR.RED_MEDIUM};
`

const SufficientInsufficientBalanceText = styled(Body)`
  font-size: ${FONT_SIZE.SMALL};
  color: ${COLOR.GREY_DARK};
  margin-bottom: ${SPACING.S};
`

const OrderChargeMessage = styled(Body)`
  font-size: ${FONT_SIZE.SMALL};
  color: ${COLOR.GREY_DARK};
  margin: ${SPACING.M} 0 0;
  padding-top: ${SPACING.M};
  border-top: 1px solid ${COLOR.GREY_LIGHT};
`

const WalletBalance = Body

export {
  OrderChargeMessage,
  SufficientInsufficientBalanceText,
  StyledTextLink,
  ErrorMessage,
  WalletBalance,
}
